import styles from './RepositionModal.module.css';
import { useCallback, useState } from 'react';
import Modal from '../../misc/modal/Modal';
import Toggle from '../../misc/toggle/Toggle';
import RepositionWidth from '../RepositionWidth/RepositionWidth';
import Button from '../../misc/Button/Button';
import ContentContainer from '../../misc/ContentContainer/ContentContainer';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import ContentHeader from '../../misc/ContentHeader/ContentHeader';
import Divider from '../../misc/Divider/Divider';
import { Link } from 'react-router-dom';
import RepositionAdvancedMode from '../RepositionAdvancedMode/RepositionAdvancedMode';

const RepositionModal = () => {
  const [showModal, setShowModal] = useState(true);
  const [AddLiquidity, setAddLiquidity] = useState(false);
  const [ advancedMode, setAdvancedMode] = useState(false)

  const openModal = useCallback(() => {
    setShowModal(true);
  }, [setShowModal]);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, [setShowModal]);

  const RepositionHeader = (
    <ContentHeader>
      <Link to='/analyticsv2'>
        <AiOutlineArrowLeft />
      </Link>
      <span>Liquidity</span>
      <div>{''}</div>
    </ContentHeader>
  );

  const DenominationContent = (
    <div className={styles.denomination_container}>
      <span>Denomination</span>
      <span>ETH</span>
      <span>USDC</span>
    </div>
  );

  const advancedModeToggle = (
    <div className={styles.advanced_toggle}>
      <span className={styles.advanced_toggle_title}>Advanced Mode</span>
      <div className={styles.advanced_toggle_container}></div>
      <Toggle
        isOn={advancedMode}
          handleToggle={() => setAdvancedMode(!advancedMode)}
        Width={40}
        id='advanced_reposition'
      />
    </div>
  );

  const toggleButtons = (
    <div className={styles.reposition_toggle_buttons_container}>
      <button
        className={
          !AddLiquidity ? styles.active_button : styles.non_active_button
        }
        onClick={() => setAddLiquidity(!AddLiquidity)}
      >
        Reposition
      </button>
      <button
        className={
          AddLiquidity ? styles.active_button : styles.non_active_button
        }
        onClick={() => setAddLiquidity(!AddLiquidity)}
      >
        Add
      </button>
    </div>
  );

  const PriceInfo = (
    <div className={styles.price_info_container}>
      <span className={styles.apy}> Est.APY | 35.65%</span>
      <div className={styles.price_info_content}>
        <div className={styles.price_display}>
          <span className={styles.price_title}>Min Price</span>
          <span className={styles.min_price}>$2,100.00</span>
        </div>
        <div className={styles.price_display}>
          <span className={styles.price_title}>Current Price</span>
          <span className={styles.current_price}>$2,658.00</span>
        </div>
        <div className={styles.price_display}>
          <span className={styles.price_title}>Max Price</span>
          <span className={styles.max_price}>$4000.00</span>
        </div>
      </div>
      <div className={styles.collateral_container}>
        <div className={styles.collateral_display}>
          <span className={styles.collateral_title}>ETH Collateral</span>
          <span className={styles.collateral_amount}>1.69</span>
        </div>
        <div className={styles.collateral_display}>
          <span className={styles.collateral_title}>USDC Collateral</span>
          <span className={styles.collateral_amount}>5,000.00</span>
        </div>
      </div>
    </div>
  );

  const confirmButton = (
    <div className={styles.confirm_button}>
      <Button title='Confirm' />
    </div>
  );

  const advancedModeOrNull = (
    !advancedMode?
      <>
        <RepositionWidth />
        <Divider />
        {PriceInfo}
      </> : 
      <RepositionAdvancedMode/>
  )

  const ModalContent = (
    <>
      {RepositionHeader}
      {DenominationContent}
      {toggleButtons}
      {advancedModeToggle}
    {advancedModeOrNull}
      {confirmButton}
    </>
  );

  const ModalOrNull = showModal ? (
    <Modal onClose={closeModal} title='Liquidity' content={ModalContent} />
  ) : null;
  return <ContentContainer>{ModalContent}</ContentContainer>;
};

export default RepositionModal;
